import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CollapsibleSuggestionsPanel } from './ItemSuggestions';

export const CART_RETURNS_POLICY_TITLE_KEY = 'cartReturnsPolicy.title';

const PolicyBody = styled.div`
  color: #1e293b;
  font-size: 0.95rem;
  line-height: 1.55;

  p {
    margin: 0 0 0.75rem;
    color: #334155;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

const CartReturnsPolicy = ({ defaultExpanded = false }) => {
  const { t } = useTranslation();

  return (
    <CollapsibleSuggestionsPanel
      title={t(CART_RETURNS_POLICY_TITLE_KEY)}
      defaultExpanded={defaultExpanded}
    >
      <PolicyBody>
        <p>{t('cartReturnsPolicy.acceptance')}</p>
        <p>{t('cartReturnsPolicy.payout')}</p>
        <p>{t('cartReturnsPolicy.marketplaceNotice')}</p>
      </PolicyBody>
    </CollapsibleSuggestionsPanel>
  );
};

export default CartReturnsPolicy;
